module.exports = __webpack_public_path__ + "c1b35cf98892e230be554e98eb3e74f1.svg";